import React, { createContext, useContext, useState } from "react";

const ContactContext = createContext();

export const ContactProvider = ({ children }) => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  const openContactModal = () => setIsContactOpen(true);
  const closeContactModal = () => setIsContactOpen(false);
  const toggleContactModal = () => setIsContactOpen((prev) => !prev);

  return (
    <ContactContext.Provider
      value={{
        isContactOpen,
        openContactModal,
        closeContactModal,
        toggleContactModal,
      }}
    >
      {children}
    </ContactContext.Provider>
  );
};

export const useContactModal = () => {
  const context = useContext(ContactContext);
  if (!context) {
    throw new Error("useContactModal must be used within a ContactProvider");
  }
  return context;
};
